/**
 * Created by Mattias on 2014-09-18.
 */
define('payment/getPaymentResult',['jquery', 'boxes/events/paymentEvent', 'all/paymentServices-toggles'], function($, paymentEvent, paymentServicesToggles) {

    'use strict';

    var SUCCESSFUL_STATE = 'successful';
    var CANCELLED_STATE = 'cancelled';
    var PENDING_STATE = 'pending';
    var NOT_FOUND_STATE = 'notFound';

    var DEFAULT_TOTAL_TIME_TO_WAIT_MS = 15000;
    var DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION = 6000;
    var DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS = 3000;
    var DEFAULT_SERVER_URL = '/pp?flow=GetDepositResult';
    var DEFAULT_SERVER_URL_PFDS = '/PaymentFormDataService/getDepositResult';

    //var paymentControllers = {deposit: depositController, withdraw : withdrawController};
    var paymentController;

    function getDefaultServerUrl() {
        return paymentServicesToggles.useNewPaymentFormDataService() ? DEFAULT_SERVER_URL_PFDS : DEFAULT_SERVER_URL;
    }

    function start(paymentControllerRef) {
        paymentController = paymentControllerRef;
    }

    function getAsynchronousPaymentResultAndShowFinalResult(accHistRef, serverUrl, playerCancel, playerRedirectedToFailUrl, totalTimeToWaitInMs,
                                                            handlePaymentResultCallback, doneCallback, continuePollingCallback) {

        if(serverUrl === undefined || serverUrl === null) {
            serverUrl = getDefaultServerUrl();
        }

        if(handlePaymentResultCallback === undefined || handlePaymentResultCallback === null) {
			handlePaymentResultCallback = defaultHandlePaymentResultCallback;
        }

        if(totalTimeToWaitInMs === undefined ||  totalTimeToWaitInMs === null) {

            if(playerRedirectedToFailUrl === true) {
                totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION;
            } else {
                totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS;
            }
        }

        if(doneCallback === undefined || doneCallback === null) {
            doneCallback = function(){};
        }

        if(continuePollingCallback === undefined || continuePollingCallback === null) {
            continuePollingCallback = function() {return true;};
        }

        var numberOfTimesToTry = Math.floor(totalTimeToWaitInMs/DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS);

        pollPaymentResult(serverUrl, handlePaymentResultCallback, numberOfTimesToTry, DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS, accHistRef, doneCallback,
            continuePollingCallback, playerCancel, playerRedirectedToFailUrl);
    }

    // getAsynchronousDepositResultNumberOfTimes is for now polling
    // A different approach could be to use wait() and notify() on server side (Long polling), letting this be one long ajax call instead of poll
    // Polling approach seems to be less complicated than web sockets or long polling
    function pollPaymentResult(serverUrl, handlePaymentResultCallback, numberOfTimesToTry, waitTimeBetweenTriesMs, accHistRef, doneCallback,
                               continuePollingCallback, playerCancel, playerRedirectedToFailUrl) {

        setTimeout(function () {
            $.post(serverUrl, {
                accHistRef: accHistRef,
                playerCancel: playerCancel,
                playerRedirectedToFailUrl: playerRedirectedToFailUrl,
                numberOfTimesToTry: numberOfTimesToTry
            }, function (data) {

                if (handlePaymentResultCallback(data)) {
                    // Here we have started to show successful or cancelled final result for the player
                    doneCallback();
                    return;
                }

                numberOfTimesToTry--;
                if (numberOfTimesToTry > 0 && continuePollingCallback() === true) {

                    pollPaymentResult(serverUrl, handlePaymentResultCallback, numberOfTimesToTry, waitTimeBetweenTriesMs, accHistRef, doneCallback,
                        continuePollingCallback, playerCancel, playerRedirectedToFailUrl);

                } else {
                    paymentController.trigger(paymentEvent.REMOVE_LOADING);
					// Out of luck? Show playerCancel, or pending final result or error msg if the transaction is not found yet
					if (data.state === PENDING_STATE) {
						showPendingFinalResult(data);
					} else if (data.state === NOT_FOUND_STATE && continuePollingCallback() === true) {
						showFailMessageBox(data);
					}

					doneCallback();
                }
            });
        }, waitTimeBetweenTriesMs);
    }

    function getSynchronousDepositResultAndShowFinalResult(accHistRef, serverUrl, handlePaymentResultCallback) {

        if(serverUrl === undefined || serverUrl === null){
            serverUrl = getDefaultServerUrl();
        }

        if(handlePaymentResultCallback === undefined || handlePaymentResultCallback === null) {
			handlePaymentResultCallback = defaultHandlePaymentResultCallback;
        }

        $.post(serverUrl, {accHistRef: accHistRef}, function (data) {
            handlePaymentResultCallback(data);
        });
    }

    function defaultHandlePaymentResultCallback(data) {

        console.info('getPaymentResult responseDataFromServer: ');
        console.info(data);

        var state = data.state;

        if((state === PENDING_STATE && data.willStayInPending === false) || state === NOT_FOUND_STATE) {

            // Show that we want another poll by returning false
            return false;

        } else if(data.willStayInPending === true) {

            showPendingFinalResult(data);
            return true;

        } else {

            if(state === SUCCESSFUL_STATE) {
                showSuccessfulFinalResult(data);
            } else {
                showFailMessageBox(data);
            }

            // Show that we are happy by returning true, so no need for another poll
            return true;
        }
    }

    function showSuccessfulFinalResult(data) {

		if (data.isInstantDeposit) {
			$(window.instantdeposit).trigger(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED, data);
		} else {
			paymentController.trigger(paymentEvent.TOTAL_BALANCE_AFTER_TRANSACTION, data.totalBalance);
			paymentController.trigger(paymentEvent.AMOUNT_IN_TRANSACTION, data.amount);
			paymentController.nextBox();
			paymentController.trigger(paymentEvent.PIXEL_TRACKING, data.pixelTrackingData);
			paymentController.trigger(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED);
			$(window.instantdeposit).trigger('RESET');
		}
    }

    function showPendingFinalResult(data) {
		if(typeof(paymentController) !== 'undefined') {
			paymentController.trigger(paymentEvent.PENDING);
			paymentController.trigger(paymentEvent.AMOUNT_IN_TRANSACTION, data.amount);
			paymentController.nextBox();
		} else{
			$(window.instantdeposit).trigger(paymentEvent.PENDING, data);
		}
    }

    function showFailMessageBox(data) {
		if(typeof(paymentController) !== 'undefined') {
			paymentController.trigger(paymentEvent.SHOW_FAIL_MESSAGE, data.errorMessage);
		} else{
			$(window.instantdeposit).trigger(paymentEvent.TRANSACTION_FAILED, data);
		}
    }

    var getPaymentResult = {};
    getPaymentResult.start = start;
    getPaymentResult.getAsynchronousPaymentResultAndShowFinalResult = getAsynchronousPaymentResultAndShowFinalResult;
    getPaymentResult.getSynchronousDepositResultAndShowFinalResult = getSynchronousDepositResultAndShowFinalResult;

    if(window.top.getPaymentResult === undefined) {
        window.top.getPaymentResult = getPaymentResult;
    }

    return window.top.getPaymentResult;
});

